import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { map, of, switchMap, take } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const userService = inject(UserService);
    const authService = inject(AuthService);

    // Check the authentication status
    return inject(AuthService).check().pipe(
        switchMap((authenticated) => {
            // If the user is not authenticated...
            if (!authenticated) {
                // Redirect to the sign-in page with a redirectUrl param
                const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
                const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                return of(urlTree);
            }

            // Allow the access
            return authService.user$.pipe(
                take(1),
                map(user => {
                    // Check if the user is defined and does not need a forced password reset
                    if (user && user.forcePasswordReset && state.url) {
                        console.log(state.url)
                        // Check if the current URL is already 'password-reset'
                        if (['/sign-out', '/password-reset'].includes(state.url)) {
                            return true; // Allow the user to pass
                        }

                        // If not, construct the redirect URL
                        // const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
                        const urlTree = router.parseUrl(`password-reset`);

                        return urlTree;
                    }
                    if (user && !user.termsAcceptedAt) {
                        if (state.url === '/accept-cgu') {
                            return true;
                        }

                        const redirectUrl = encodeURIComponent(state.url);
                        const urlTree = router.parseUrl(`accept-cgu`);

                        return urlTree;
                    }
                    return true;
                })
            );

        }),
    );
};


export const CGUGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const userService = inject(UserService);
    const authService = inject(AuthService);

    // Check the authentication status
    return authService.check().pipe(
        switchMap((authenticated) => {
            // If the user is not authenticated...
            if (!authenticated) {
                // Redirect to the sign-in page with a redirectUrl param
                const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
                const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                return of(urlTree);
            }

            return authService.user$.pipe(
                take(1),
                map(user => {
                    if (user && user.termsAcceptedAt) {
                        // Return a UrlTree to redirect to the dashboard if CGU are accepted
                        return router.parseUrl('/dashboard');
                    }

                    if (user && !user.termsAcceptedAt) {
                        if (state.url === '/accept-cgu') {
                            return true;
                        }
                    }

                    return false;
                })
            );
        }),
    );
};
